export default "__VITE_ASSET__39fe0ce2__"